import React, {useState} from 'react';
import InfoGlobalGraph from "../InfoGlobalGraph/InfoGlobalGraph.js";
import InfoGlobalHistorique from '../InfoGlobalHistorique/InfoGlobalHistorique.js';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowUp} from '@fortawesome/free-solid-svg-icons';

/**
 *  InfoGlobalBaseView
 * @return {JSX}
 */
function InfoGlobalBaseView(props) {

  const [showDropdown, setShowDropdown] = useState(false);

    /**
   * Permet de gérer le dropdown
   * @param {*} event event
   */
    function toggleDropdown(event) {
      setShowDropdown(event.target.value);
      props.setWhatToShowGlobal(event.target.value);
    }
  
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    };

    const windowWidth = window.innerWidth;
    const isMobile = windowWidth <= 600;

  return (
    <div className="chantierinfo-container">
      <div className="buttons-container">
        
        <div className="chantierinfo-buttons2-container">
         
          {localStorage.getItem('admin') === '1' ?
          <button
            className={props.whatToShowGlobal === '1' ? 'chantierinfo-button2selected' : 'chantierinfo-buttons2'}
            value={1}
            onClick={(event) => toggleDropdown(event)}>Historique</button> : '' }

          {localStorage.getItem('admin') === '1' ?
          <button
            className={props.whatToShowGlobal === '2' ? 'chantierinfo-button2selected' : 'chantierinfo-buttons2'}
            value={2}
            onClick={(event) => toggleDropdown(event)}>Graphique</button> : '' }
        </div>
      
      </div>
      {
       props.whatToShowGlobal === '1' ? <InfoGlobalHistorique/> :
      <InfoGlobalGraph />}

      <button className="chantierinfo-scroll-to-top-button" onClick={scrollToTop}>
        <FontAwesomeIcon icon={faArrowUp}></FontAwesomeIcon>
      </button>
    </div>
  );
}

export default InfoGlobalBaseView; 